// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1qFgl","itemTitle":"ClientEmergencyInfo_itemTitle__KE0XD","itemText":"ClientEmergencyInfo_itemText__1trlW"};